import { createFileRoute } from '@tanstack/react-router';
import StatisticsPage from '../../../features/bed-management/pages/StatisticsPage';
import { getUnitsQueryOptions } from '../../../features/bed-management/queries';

export const Route = createFileRoute('/_auth/bed-management/statistics')({
  component: RouteComponent,
  loader: async ({ context }) => {
    const { user, healthCenter } = context.authenticationContext;
    if (!user || !healthCenter) {
      return undefined;
    }

    const userUnitIds = user.units?.map((unit) => unit.id) || [];

    return context.queryClient.ensureQueryData(getUnitsQueryOptions('healthCenter', healthCenter, userUnitIds));
  },
});

function RouteComponent() {
  const { user, healthCenter } = Route.useRouteContext().authenticationContext;
  const userUnitIds = user?.units?.map((unit) => unit.id) || [];

  return <StatisticsPage userUnitIds={userUnitIds} healthCenter={healthCenter} />;
}
